import { FC } from 'react'
import { useDrop } from 'react-dnd'
import userIcon from '../../../../images/user-icon.svg';
import userIconThick from '../../../../images/user-thick.svg'
import userIconRed from '../../../../images/user-red.svg'
import userIconWarn from '../../../../images/red-warn.svg'
import userEdit from '../../../../images/user-edit.svg'
import { AxiosError, AxiosResponse } from 'axios';
import { toast } from "react-toastify";
import Service from '../../../../services';

export interface TestDropItemProps {
  allowedDropEffect?: string;
  el: [];
  index: number;
  validateIndex?: number[];
  setPanelDragData: React.Dispatch<any>;
  panelDragData: any;
  ownersData: any;
  setOwnersData: any;
  setValidateIndex: React.Dispatch<React.SetStateAction<number[]>>
  editMode: boolean;
  getIndividuals: () => void;
  setLoad: React.Dispatch<React.SetStateAction<boolean>>;
  disableFields: boolean | undefined;
  getAllOwnershipContacts: () => void;
}

function selectBackgroundColor(isActive: boolean, canDrop: boolean) {
  if (isActive) {
    return '#79869f'
  } else if (canDrop) {
    return '#c3c9d4'
  }
}

export const DropItem: FC<TestDropItemProps> = ({ allowedDropEffect, el, index, validateIndex,
  setPanelDragData, panelDragData, disableFields,
  ownersData, setOwnersData, setValidateIndex, editMode, getIndividuals, setLoad, getAllOwnershipContacts }) => {
  const service = new Service();
  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: "card",
      drop: (item: any) => {
        const upDragList = [...panelDragData];
        const isParentOrSameChild = upDragList[index].some((ele: any) => ele.parentOwnerId == item.parentOwnerId)
        if (!isParentOrSameChild) {
          upDragList[index].push(item);
          setPanelDragData(upDragList);
          setValidateIndex([])
          const upOrgList = [...ownersData];
          const found = upOrgList.find((id: any) => id.ownerId === item.ownerId)
          const inde = upOrgList.indexOf(found);
          item = { ...item, grouped: true }
          upOrgList[inde] = { ...item, grouped: true };
          setOwnersData(upOrgList)
        }
        else {
          toast.error("Not possible to group");
        }
        return {
          name: `${allowedDropEffect} TestDropItem`,
          allowedDropEffect,
        }
      },
      collect: (monitor: any) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [ownersData],
  )

  const deleteItem = (dat: any) => {
    const upDragList = [...panelDragData];
    const x = upDragList[index].filter((elss: any) => elss.ownerId !== dat.ownerId)
    upDragList[index] = x
    setPanelDragData(upDragList);
    setValidateIndex([])

    const upOrgList = [...ownersData];
    const found = upOrgList.find((id: any) => id.ownerId === dat.ownerId)
    const inde = upOrgList.indexOf(found);
    dat = { ...dat, grouped: true }
    upOrgList[inde] = { ...dat, grouped: false };
    setOwnersData(upOrgList)
    getIndividuals()
    if (dat?.individualId) {
      service.removeIndividualFromGroup(dat?.individualId).then((res: any) => {
        getAllOwnershipContacts()
      }).catch((error: AxiosError) => {
        console.log(error)
      })
    }
  }

  const iconSet = (els: []) => {
    if (!editMode) {
      if (validateIndex?.includes(index)) {
        return userIconRed
      }
      else if (els.length > 0) {
        return userIconThick
      }
      else {
        return userIcon
      }
    }
    else {
      return userEdit
    }
  }
  const isActive = canDrop && isOver
  const backgroundColor = selectBackgroundColor(isActive, canDrop)
  return (
    <div ref={drop} style={{ backgroundColor }} className="draggedRow">
      <img className="userIcon" src={iconSet(el)}
        alt="userIcon" />
      <div className='draggedItems'>
        {el?.map((dat: any, itemindex: number) => (<div className={`dragedItem ${editMode ? 'editMode' : ""}`}
          key={itemindex}>
          <div className='draggedOwnerName'>{dat?.firstname + " " + dat?.lastname}</div>
          {!editMode && !disableFields && <span className="crossIcon" onClick={() => deleteItem(dat)}>X</span>}
        </div>))}
      </div>
      <img className="userIcon" src={validateIndex?.includes(index) ? userIconWarn : ""} />
    </div>
  )
}
